/* .panel-items layout moved to Interstate Tailwind utilities in SupportMenuPanel.ts;
   only the native ::backdrop styling remains here. The base/utilities layer comes from
   the shared ../../../styles/tailwind-shared.css import in SupportMenuPanel.ts (ARGUS
   PR #164 CRITICAL).
   NOTE: the components layer (../../../styles/tailwind-components.css) is intentionally
   NOT imported — the panel emits no `.ids-*` classes. The slide-out recipe (`.ids-slideout
   { display:flex }` et al.) now lives inside <support-menu-slideout>'s own shadow root, on
   its inner surface — not on the host and not in this scope — so pulling in the DIY
   component layer here would be dead CSS. Lossless. */

:host {
  display: block;
}

/* Backdrop dim + fade for the support-menu-slideout popover. Native ::backdrop has no default
   fill, so set the dim here; allow-discrete keeps it in the top layer to fade on close.
   Token-first (ARGUS PR #164 MINOR): sourced from Interstate's overlay-dark token, hex kept
   only as the fallback for when the token custom property isn't defined. */
support-menu-slideout::backdrop {
  background-color: var(--sem-color-overlay-dark, rgba(74, 74, 74, 0.8));
  opacity: 0;
  transition:
    opacity 0.5s ease-in-out,
    overlay 0.5s allow-discrete,
    display 0.5s allow-discrete;
}

support-menu-slideout:popover-open::backdrop {
  opacity: 1;
}

@starting-style {
  support-menu-slideout:popover-open::backdrop {
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  support-menu-slideout::backdrop {
    transition: none;
  }
}
